import { render, staticRenderFns } from "./map-china.vue?vue&type=template&id=e8a64fc6&scoped=true&"
import script from "./map-china.component.ts?vue&type=script&lang=ts&"
export * from "./map-china.component.ts?vue&type=script&lang=ts&"
import style0 from "./map-china.scss?vue&type=style&index=0&id=e8a64fc6&lang=scss&scoped=true&"
import style1 from "./map-china.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a64fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a64fc6')) {
      api.createRecord('e8a64fc6', component.options)
    } else {
      api.reload('e8a64fc6', component.options)
    }
    module.hot.accept("./map-china.vue?vue&type=template&id=e8a64fc6&scoped=true&", function () {
      api.rerender('e8a64fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/map-china/map-china.vue"
export default component.exports